<div *ngIf="showDivider" class="divider"></div>

<div *ngIf="showLoader || title || isClosable" class="twc-ml-2 twc-pl-2 twc-pr-2 principal-container">
    <twc-loader *ngIf="showLoader" class="twc-mr-3 twc-mt-1 yellow" size="tiny"></twc-loader>
    <h5 class="twc-h5 twc-mt-2 yellow"> {{title | translate}}</h5>
    <button *ngIf="isClosable" class="twc-button twc-button-link twc-button-icon button-container"
        (click)="onCloseClicked()" [twcTooltip]="'GENERAL.CANCEL' | translate" placement="top">
        <twc-icon shape="close" [size]="32"></twc-icon>
    </button>
</div>

<div class="percentage twc-d-flex twc-ml-2 twc-mr-2 twc-pl-3 twc-pr-3 width-100"
    [ngClass]="{'indeterminate': isIndeterminate}">
    <twc-progress-bar class="progress-bar" [progress]="progressStatus" [height]="height" [type]="type">
    </twc-progress-bar>
    <span class="percentage-number" *ngIf="isPercentageVisible">{{progressStatus | number: '1.0-0'}} %</span>
</div>